import React, { useEffect, useState } from "react";
import Footer from "../footer";
import Nav from "../../master/NavBar";
import Header from "../../master/SideBar";
import { LoadingDiv, SweetAlertShow, ToastMain } from "../../master/Master";
import {
  StaffsendAbsentMsg,
  StaffsendPresentMsg,
  StaffSinglePresent,
  todayStaffAttendance,
} from "../../../api/Staff";
import { getSessions } from "../../../api/SessionsService";
import Swal from "sweetalert2";
import { formatToTime } from "../../master/FormatToDateTime";
import StaffLayout from "../../staffs/StaffLayout";
import { imgBaseUrl } from "../../../api/api";

const StaffAttendance = () => {
  const [staffs, setStaffs] = useState({ data: [] });
  const [summary, setSummary] = useState({});
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSessions] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("");

  const [attendanceModal, setAttendanceModal] = useState([]);
  const [attendanceStaff, setAttendanceStaff] = useState(null);

  // ================= SESSION =================
  const getSession = async () => {
    try {
      const res = await getSessions();
      if (res?.data?.status) {
        setSessions(res.data.data);
        const active = res.data.data.find((s) => s.status === "1");
        if (active) setSelectedSessions(active.id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ================= FETCH =================
  // const fetchData = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await todayStaffAttendance(
  //       `&session=${selectedSession}&date=${selectedDate}`
  //     );

  //     if (res?.data?.status) {
  //       const list = Array.isArray(res.data.data)
  //         ? res.data.data
  //         : [res.data.data];

  //       setStudents({ data: list });
  //       setSummary(res.data);
  //     }
  //   } catch (err) {
  //     SweetAlertShow("error", "Error", err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await todayStaffAttendance(
        `&session=${selectedSession}&date=${selectedDate}&sort=${sortBy}`,
      );

      if (res?.data?.status) {
        const list = Array.isArray(res.data.data)
          ? res.data.data
          : [res.data.data];

        setStaffs({ data: list });

        const total = list.length;

        const present = list.filter((s) =>
          s.attendances?.some((a) => a.check_in === "1" && a.is_leave === "2"),
        ).length;

        const absent = list.filter((s) =>
          s.attendances?.some((a) => a.is_leave === "1"),
        ).length;

        const notMarked = total - (present + absent);

        setSummary({
          total_staff: total,
          present_staff: present,
          absent_staff: absent,
          not_marked: notMarked,
        });
      }
    } catch (err) {
      SweetAlertShow("error", "Error", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchAttendance = async () => {
    try {
      const res = await todayStaffAttendance();
      if (res?.data?.status) {
        setData(res.data.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  useEffect(() => {
    if (selectedSession) {
      fetchData();
      fetchAttendance();
    }
  }, [selectedSession, selectedDate, sortBy]);

  // ================= SAVE =================
  const handleAttendance = async (student, type) => {
    let time = null;

    if (type !== "absent") {
      const now = new Date();
      const currentTime = now.toTimeString().slice(0, 5);

      const resTime = await Swal.fire({
        title: `Select ${type.toUpperCase()} Time`,
        input: "time",
        inputValue: currentTime,
        showCancelButton: true,
      });

      if (!resTime.value) return;
      time = resTime.value;
    }

    try {
      const res = await StaffSinglePresent({
        registration_no: student.registration_no,
        date: selectedDate,
        type,
        time,
      });

      if (res?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: res?.data?.message || "Saved",
        });
        fetchData();
        fetchAttendance();
      } else {
        SweetAlertShow("info", "Warning", res?.data?.message);
      }
    } catch (err) {
      SweetAlertShow("error", "Error", err.message);
    }
  };

  const handleSendMessage = async (type) => {
    let apiCall = type === "present" ? StaffsendPresentMsg : StaffsendAbsentMsg;

    const confirm = await Swal.fire({
      title: "Confirm?",
      text: `Send message to ${type} staff`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "OK",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await apiCall({
        date: selectedDate,
      });

      if (res?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: res.data.message,
        });
      }
    } catch (err) {
      SweetAlertShow("error", "Error", err.message);
    }
  };

  const openAttendanceModal = (staff, attendance) => {
    setAttendanceStaff(staff);
    setAttendanceModal(attendance);

    const modal = new window.bootstrap.Modal(
      document.getElementById("attendanceDetailsModal"),
    );

    modal.show();
  };
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <StaffLayout />
                  <div className="col-12">
                    {/* Header */}
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body">
                        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center">
                          <div>
                            <h3 className="fw-bold text-primary mb-1">
                              <i className="ri-calendar-check-line me-2"></i>
                              Staff Attendance
                            </h3>
                            <p className="text-muted mb-0">
                              Mark and monitor daily attendance of all staff
                              members.
                            </p>
                          </div>
                          {/* <div className="d-flex flex-wrap gap-2 mt-3 mt-lg-0">
                            <button
                              className="btn btn-success"
                              onClick={() => handleSendMessage("present")}
                            >
                              <i className="ri-mail-send-line me-1"></i>
                              Present SMS
                            </button>
                            <button
                              className="btn btn-danger"
                              onClick={() => handleSendMessage("absent")}
                            >
                              <i className="ri-mail-send-line me-1"></i>
                              Absent SMS
                            </button>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    {/* Summary */}
                    <div className="row g-3 mb-4">
                      <div className="col-md-3">
                        <div className="card border-0 shadow-sm h-100">
                          <div className="card-body">
                            <div className="d-flex justify-content-between">
                              <div>
                                <small className="text-muted">
                                  Total Staff
                                </small>
                                <h3 className="fw-bold mt-2">
                                  {summary?.total_staff || 0}
                                </h3>
                              </div>
                              <div
                                className="rounded-circle bg-label-primary d-flex align-items-center justify-content-center"
                                style={{
                                  width: 55,
                                  height: 55,
                                }}
                              >
                                <i className="ri-team-line fs-3 text-primary"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="card border-0 shadow-sm h-100">
                          <div className="card-body">
                            <div className="d-flex justify-content-between">
                              <div>
                                <small className="text-muted">Present</small>
                                <h3 className="fw-bold text-success mt-2">
                                  {summary?.present_staff || 0}
                                </h3>
                              </div>
                              <div
                                className="rounded-circle bg-label-success d-flex align-items-center justify-content-center"
                                style={{
                                  width: 55,
                                  height: 55,
                                }}
                              >
                                <i className="ri-checkbox-circle-line fs-3 text-success"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="card border-0 shadow-sm h-100">
                          <div className="card-body">
                            <div className="d-flex justify-content-between">
                              <div>
                                <small className="text-muted">Absent</small>
                                <h3 className="fw-bold text-danger mt-2">
                                  {summary?.absent_staff || 0}
                                </h3>
                              </div>
                              <div
                                className="rounded-circle bg-label-danger d-flex align-items-center justify-content-center"
                                style={{
                                  width: 55,
                                  height: 55,
                                }}
                              >
                                <i className="ri-close-circle-line fs-3 text-danger"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="card border-0 shadow-sm h-100">
                          <div className="card-body">
                            <div className="d-flex justify-content-between">
                              <div>
                                <small className="text-muted">Not Marked</small>

                                <h3 className="fw-bold text-warning mt-2">
                                  {summary?.not_marked || 0}
                                </h3>
                              </div>
                              <div
                                className="rounded-circle bg-label-warning d-flex align-items-center justify-content-center"
                                style={{
                                  width: 55,
                                  height: 55,
                                }}
                              >
                                <i className="ri-time-line fs-3 text-warning"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Filters */}
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body">
                        <div className="row align-items-end g-3">
                          <div className="col-lg-3">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="date"
                                className="form-control"
                                value={selectedDate}
                                onChange={(e) =>
                                  setSelectedDate(e.target.value)
                                }
                              />
                              <label>Attendance Date</label>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                              >
                                <option value="">Default</option>
                                <option value="name_asc">Name (A-Z)</option>
                                <option value="name_desc">Name (Z-A)</option>
                                <option value="reg_asc">
                                  Reg No (Ascending)
                                </option>
                                <option value="reg_desc">
                                  Reg No (Descending)
                                </option>
                              </select>
                              <label>Sort By</label>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <button
                              className="btn btn-primary w-100"
                              onClick={fetchData}
                            >
                              <i className="ri-refresh-line me-1"></i>
                              Refresh Attendance
                            </button>
                          </div>
                          <div className="col-lg-3">
                            <div className="alert alert-primary mb-0 py-2 text-center">
                              <strong>{staffs?.data?.length || 0}</strong> Staff
                              Loaded
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* TABLE */}
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-header bg-transparent border-bottom py-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h5 className="fw-bold mb-1">
                              <i className="ri-team-line text-primary me-2"></i>
                              Staff Attendance Register
                            </h5>
                            <small className="text-muted">
                              Mark attendance and monitor staff
                              check-in/check-out.
                            </small>
                          </div>
                        </div>
                      </div>
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th style={{ width: "60px" }}>#</th>

                                <th style={{ minWidth: "340px" }}>Employee</th>

                                <th style={{ minWidth: "240px" }}>Contact</th>

                                <th style={{ width: "170px" }}>Department</th>

                                <th style={{ width: "200px" }}>
                                  Attendance Status
                                </th>

                                <th
                                  className="text-center"
                                  style={{ width: "140px" }}
                                >
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {staffs.data.map((row, index) => {
                                const TodayAttendance =
                                  data.find(
                                    (a) =>
                                      a?.registration_no ===
                                      row?.registration_no,
                                  )?.attendances || [];

                                const latest =
                                  TodayAttendance.length > 0
                                    ? TodayAttendance[
                                        TodayAttendance.length - 1
                                      ]
                                    : null;

                                const isAbsent =
                                  latest?.type === "absent" ||
                                  latest?.is_leave === "1";

                                const isIn =
                                  latest?.check_in === "1" &&
                                  latest?.check_out !== "1";

                                const isOut =
                                  latest?.check_out === "1" &&
                                  latest?.is_leave === "2";

                                return (
                                  <tr key={row.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <div
                                        className="d-flex align-items-center"
                                        style={{ minWidth: "320px" }}
                                      >
                                        <div
                                          className="me-3 flex-shrink-0"
                                          style={{
                                            width: 56,
                                            height: 56,
                                          }}
                                        >
                                          {row?.img ? (
                                            <img
                                              src={`${imgBaseUrl}${row.img}`}
                                              alt={row.name}
                                              className="rounded-circle border shadow-sm"
                                              style={{
                                                width: "56px",
                                                height: "56px",
                                                objectFit: "cover",
                                              }}
                                            />
                                          ) : (
                                            <div
                                              className="rounded-circle bg-label-primary d-flex align-items-center justify-content-center fw-bold text-primary"
                                              style={{
                                                width: "56px",
                                                height: "56px",
                                                fontSize: "18px",
                                              }}
                                            >
                                              {row?.name
                                                ?.split(" ")
                                                ?.map((word) => word[0])
                                                ?.slice(0, 2)
                                                ?.join("")
                                                ?.toUpperCase()}
                                            </div>
                                          )}
                                        </div>
                                        <div>
                                          <div>
                                            <div className="fw-semibold">
                                              {row.name}
                                            </div>

                                            <div className="small text-muted">
                                              {row.registration_no}

                                              <span className="mx-2">•</span>

                                              {row.staff_type}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td style={{ minWidth: "220px" }}>
                                      <div className="small">
                                        <div>
                                          <i className="ri-phone-line me-1 text-primary"></i>

                                          {row.mobile}
                                        </div>

                                        {row.email && (
                                          <div className="text-muted mt-1">
                                            <i className="ri-mail-line me-1"></i>

                                            {row.email}
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <span className="badge bg-label-info rounded-pill px-2 py-2">
                                        {row.staff_type}
                                      </span>
                                    </td>
                                    <td className="text-center">
                                      {!latest && (
                                        <div>
                                          <span className="badge bg-label-warning rounded-pill px-3 py-2">
                                            <i className="ri-time-line me-1"></i>
                                            Not Marked
                                          </span>
                                        </div>
                                      )}

                                      {isAbsent && (
                                        <div>
                                          <span className="badge bg-label-danger rounded-pill px-3 py-2">
                                            <i className="ri-close-circle-fill me-1"></i>
                                            Absent
                                          </span>

                                          <div className="small text-danger mt-1">
                                            Leave / Absent
                                          </div>
                                        </div>
                                      )}

                                      {isIn && (
                                        <div>
                                          <span className="badge bg-label-success rounded-pill px-3 py-2">
                                            <i className="ri-checkbox-circle-fill me-1"></i>
                                            Checked In
                                          </span>

                                          <div className="small text-muted mt-1">
                                            <i className="ri-time-line me-1"></i>

                                            {formatToTime(latest.check_in_time)}
                                          </div>
                                        </div>
                                      )}

                                      {isOut && (
                                        <div>
                                          <span className="badge bg-label-primary rounded-pill px-3 py-2">
                                            <i className="ri-checkbox-circle-fill me-1"></i>
                                            Checked Out
                                          </span>

                                          <div className="small text-muted mt-1">
                                            <i className="ri-time-line me-1"></i>

                                            {formatToTime(
                                              latest.check_out_time,
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </td>

                                    <td className="text-center">
                                      <div className="d-flex justify-content-center align-items-center gap-2">
                                        {!latest && (
                                          <button
                                            className="btn btn-icon btn-success"
                                            title="Check In"
                                            onClick={() =>
                                              handleAttendance(row, "in")
                                            }
                                          >
                                            <i className="ri-login-circle-line"></i>
                                          </button>
                                        )}
                                        {!latest && (
                                          <button
                                            className="btn btn-icon btn-danger"
                                            title="Mark Absent"
                                            onClick={() =>
                                              handleAttendance(row, "absent")
                                            }
                                          >
                                            <i className="ri-user-unfollow-line"></i>
                                          </button>
                                        )}
                                        {isIn && (
                                          <button
                                            className="btn btn-icon btn-warning"
                                            title="Check Out"
                                            onClick={() =>
                                              handleAttendance(row, "out")
                                            }
                                          >
                                            <i className="ri-logout-circle-r-line"></i>
                                          </button>
                                        )}
                                        {isOut && (
                                          <button
                                            className="btn btn-icon btn-success"
                                            title="Check In Again"
                                            onClick={() =>
                                              handleAttendance(row, "in")
                                            }
                                          >
                                            <i className="ri-login-circle-line"></i>
                                          </button>
                                        )}
                                        {TodayAttendance.length > 0 &&
                                          !isAbsent && (
                                            <button
                                              className="btn btn-icon btn-info text-white"
                                              title="Attendance History"
                                              onClick={() =>
                                                openAttendanceModal(
                                                  row,
                                                  TodayAttendance,
                                                )
                                              }
                                            >
                                              <i className="ri-history-line"></i>
                                            </button>
                                          )}
                                      </div>

                                      {/* {isAbsent && (
                                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                                          <button
                                            className="btn btn-success rounded-pill px-3 btn-sm"
                                            onClick={() =>
                                              handleAttendance(row, "in")
                                            }
                                          >
                                            Check In
                                          </button>

                                          <span className="text-danger fw-bold">
                                            Absent Marked
                                          </span>
                                        </div>
                                      )} */}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="attendanceDetailsModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content border-0 shadow">
            <div className="modal-header bg-label-primary">
              <div>
                <h5 className="mb-1">Attendance Timeline</h5>

                <small>{attendanceStaff?.name}</small>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">
              <div className="d-flex align-items-center mb-4">
                <div
                  className="me-3"
                  style={{
                    width: 60,
                    height: 60,
                  }}
                >
                  {attendanceStaff?.img ? (
                    <img
                      src={`${imgBaseUrl}${attendanceStaff.img}`}
                      className="rounded-circle border shadow-sm"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div
                      className="rounded-circle bg-label-primary d-flex align-items-center justify-content-center fw-bold text-primary"
                      style={{
                        width: "60px",
                        height: "60px",
                        fontSize: "22px",
                      }}
                    >
                      {attendanceStaff?.name
                        ?.split(" ")
                        ?.map((x) => x[0])
                        ?.slice(0, 2)
                        ?.join("")
                        ?.toUpperCase()}
                    </div>
                  )}
                </div>

                <div>
                  <h5 className="mb-1">{attendanceStaff?.name}</h5>

                  <div className="text-muted">
                    {attendanceStaff?.registration_no}
                  </div>
                </div>
              </div>

              <hr />

              {attendanceModal.length > 0 ? (
                attendanceModal.map((att, index) => (
                  <div key={index} className="border rounded-3 p-3 mb-3">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="fw-semibold">
                          Attendance #{index + 1}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="small text-muted">Check In</div>

                        <div>
                          {att.check_in_time
                            ? formatToTime(att.check_in_time)
                            : "--"}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="small text-muted">Check Out</div>

                        <div>
                          {att.check_out_time
                            ? formatToTime(att.check_out_time)
                            : "--"}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-5">
                  <i
                    className="ri-calendar-close-line text-muted"
                    style={{
                      fontSize: 60,
                    }}
                  ></i>

                  <h5 className="mt-3">No Attendance Found</h5>
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaffAttendance;
